import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate("/");
  };

  return (
    <div
      style={{
        backgroundColor: "#f0e5d6",
        minHeight: "100vh",
        padding: "2rem 1rem",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <Card
              style={{
                borderRadius: "15px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                overflow: "hidden",
              }}
            >
              <Card.Header
                style={{
                  backgroundColor: "#3d2c22",
                  color: "white",
                  padding: "2rem",
                  textAlign: "center",
                  position: "relative",
                }}
              >
                <Link
                  to="/"
                  style={{
                    position: "absolute",
                    left: "1rem",
                    top: "1rem",
                    color: "white",
                    textDecoration: "none",
                    fontSize: "0.9rem",
                    opacity: 0.8,
                    transition: "opacity 0.3s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  ← Back to Home
                </Link>
                <h1
                  style={{
                    margin: "0 0 0.5rem 0",
                    fontSize: "2rem",
                    fontWeight: "bold",
                  }}
                >
                  Privacy Policy
                </h1>
                <p style={{ margin: 0, opacity: 0.75, fontSize: "1rem" }}>
                  The Endless Moment Pte Ltd
                </p>
              </Card.Header>

              <Card.Body
                style={{
                  padding: "2.5rem",
                  color: "#3d2c22",
                  lineHeight: "1.7",
                }}
              >
                <section
                  style={{ marginBottom: "1.5rem", textAlign: "justify" }}
                >
                  <p>
                    At The Endless Moment Pte Ltd ("The Endless Moment", "we",
                    "our", "us"), your privacy is very important to us. We are
                    committed to protecting your personal data in compliance
                    with the Personal Data Protection Act (PDPA) of Singapore.
                  </p>
                  <p>
                    This Privacy Policy explains how we collect, use, disclose,
                    and safeguard your data when you use our digital guestbook
                    and photo-sharing platform ("Service"). By using our
                    Service, you agree to the terms below.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    1. Data We Collect
                  </h3>
                  <p>
                    We may collect the following types of personal data when you
                    use our website and Service:
                  </p>
                  <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Account Information (Hosts):</strong> Name, email,
                      phone number, billing details, and account login
                      credentials.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Guest Information (Invitees):</strong> Name,
                      messages, and any photos or videos uploaded through event
                      QR codes.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Content Data:</strong> Photos, videos, guestbook
                      entries, and messages submitted to the platform.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Usage Data:</strong> IP address, browser type,
                      pages viewed, access times, and device information.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Payment Data:</strong> Processed securely by
                      third-party payment providers (we do not store your credit
                      card details).
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>System Logs:</strong> Error logs and performance
                      data to help us maintain security and reliability.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    2. How We Use Your Data
                  </h3>
                  <p>We use your personal data for purposes including:</p>
                  <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Service Delivery:</strong> To host events, upload
                      and display guest contributions, and provide event
                      galleries for download.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Account Management:</strong> To manage host
                      registrations, logins, and subscriptions.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Customer Support:</strong> To respond to
                      enquiries, feedback, and support requests.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Customization:</strong> To allow event hosts to
                      personalize their galleries (themes, layouts, slideshows).
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Security & Monitoring:</strong> To prevent fraud,
                      troubleshoot issues, and maintain system performance.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Legal & Compliance:</strong> To comply with
                      applicable laws, enforce our Terms and Conditions, and
                      protect our rights.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    3. Sharing of Data
                  </h3>
                  <p>
                    We do not sell or rent your personal data. We may share data
                    only in the following cases:
                  </p>
                  <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Service Providers:</strong> With trusted partners
                      who provide hosting, payment processing, analytics, or
                      customer support.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Legal Requirements:</strong> If disclosure is
                      required by law, court order, or to protect against misuse
                      of our Service.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      <strong>Business Transactions:</strong> If our company is
                      merged, acquired, or transferred, your data may be part of
                      the business assets.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    4. Cookies and Tracking
                  </h3>
                  <p>
                    We use cookies and similar technologies to improve your
                    browsing experience, remember preferences, and analyze
                    usage. You can manage or disable cookies through your
                    browser, but some features may not work properly without
                    them.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    5. Data Security
                  </h3>
                  <p>
                    We implement reasonable technical and organizational
                    safeguards to protect your data against loss, misuse, and
                    unauthorized access. However, no online service is 100%
                    secure, and we cannot guarantee absolute protection.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    6. Data Retention
                  </h3>
                  <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
                    <li style={{ marginBottom: "0.5rem" }}>
                      Event data (photos, videos, guestbook entries) is retained
                      for the duration of the subscription package purchased by
                      the host (e.g., 3, 6, or 12 months).
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      After the subscription period, data may be deleted,
                      archived, or anonymized. Hosts are encouraged to download
                      all event content before expiry.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      Account data may be retained as long as necessary for
                      business, legal, or compliance purposes.
                    </li>
                  </ul>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    7. Your Rights
                  </h3>
                  <p>Under the PDPA, you have the right to:</p>
                  <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
                    <li style={{ marginBottom: "0.5rem" }}>
                      Access personal data we hold about you.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      Request corrections to inaccurate or incomplete data.
                    </li>
                    <li style={{ marginBottom: "0.5rem" }}>
                      Withdraw consent for certain uses of your data (subject to
                      legal or contractual limitations).
                    </li>
                  </ul>
                  <p>
                    To exercise these rights, please contact us (see Section
                    10).
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    8. Third-Party Links
                  </h3>
                  <p>
                    Our Service may link to third-party websites (e.g., Canva
                    templates, payment portals). We are not responsible for
                    their privacy practices, and encourage you to review their
                    privacy policies.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    9. Changes to This Policy
                  </h3>
                  <p>
                    We may update this Privacy Policy from time to time. Any
                    changes will be posted on our website with a revised
                    effective date. Continued use of the Service indicates
                    acceptance of the updated terms.
                  </p>
                </section>

                <section style={{ marginBottom: "2rem", textAlign: "justify" }}>
                  <h3
                    style={{
                      color: "#917054",
                      borderBottom: "2px solid #917054",
                      paddingBottom: "0.5rem",
                      marginBottom: "1rem",
                      fontSize: "1.25rem",
                      fontWeight: "bold",
                    }}
                  >
                    10. Contact Us
                  </h3>
                  <p>
                    If you have any questions, feedback, or data access
                    requests, please contact us at:
                  </p>
                  <div
                    style={{
                      backgroundColor: "#f0e5d6",
                      border: "1px solid #917054",
                      borderRadius: "8px",
                      padding: "1rem",
                      marginTop: "1rem",
                    }}
                  >
                    <p style={{ margin: "0 0 0.5rem 0", fontWeight: "bold" }}>
                      The Endless Moment Pte Ltd
                    </p>
                    <p style={{ margin: "0 0 0.25rem 0" }}>
                      🌐{" "}
                      <a
                        href="https://theendlessmoment.com/#contactus"
                        style={{ color: "#3d2c22", textDecoration: "none" }}
                      >
                        https://theendlessmoment.com/#contactus
                      </a>
                    </p>
                    <p style={{ margin: 0 }}>
                      📧{" "}
                      <a
                        href="mailto:enquiries@theendlessmoment.com"
                        style={{ color: "#3d2c22", textDecoration: "none" }}
                      >
                        enquiries@theendlessmoment.com
                      </a>
                    </p>
                  </div>
                </section>

                <div
                  style={{
                    textAlign: "center",
                    marginTop: "2rem",
                    paddingTop: "1.5rem",
                    borderTop: "1px solid #917054",
                    color: "#666",
                    fontSize: "0.9rem",
                  }}
                >
                  <p style={{ margin: 0 }}>
                    Last updated: Please check our website for the most current
                    version of this policy.
                  </p>
                </div>
              </Card.Body>

              <Card.Footer style={{ textAlign: "center", padding: "1.5rem" }}>
                <Button
                  variant="outline-primary"
                  onClick={handleBackToHome}
                  style={{
                    backgroundColor: "#f0e5d6",
                    borderColor: "#917054",
                    color: "#3d2c22",
                  }}
                >
                  Back to Home
                </Button>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PrivacyPolicy;
